module.exports = __webpack_public_path__ + "img/pioneer.283add2c.svg";